import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import Home from "./screens/Home";
import Destination from "./screens/Destination";
import Crew from "./screens/Crew";
import Technology from "./screens/Technology";
import Nav from "./components/Nav/Nav";
import { AnimatePresence } from "framer-motion";

function App() {
	const location = useLocation();
	return (
		<div className='App'>
			<div className='w-full min-h-screen bg-black'>
				<Nav />
				<AnimatePresence exitBeforeEnter>
					<Routes location={location} key={location.pathname}>
						<Route index path='/' element={<Home />} />
						<Route index path='/destination' element={<Destination />} />
						<Route index path='/crew' element={<Crew />} />
						<Route index path='/technology' element={<Technology />} />
					</Routes>
				</AnimatePresence>
			</div>
		</div>
	);
}

export default App;
